<template>
  <v-flex data-qa="termdepositactions-flex-m8haii">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="mx-2" data-qa="termdepositactions-layout-u1wves">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="termdepositactions-flex-qwy0i">
        <v-container class="pa-6 pl-12" data-qa="termdepositactions-container-wf49ra">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="termdepositactions-flex-4o6e3a">
            <v-row no-gutters class="pb-2" data-qa="termdepositactions-row-8sj6zo">
              <inline-svg
                class="mt-2"
                :src="getNavigationIcon()"
                width="50"
                height="50"
                aria-label="Navigation Icon"
              ></inline-svg>
              <v-flex xs8 sm10 md10 lg10 xl10 class="font-weight-light text-h4 white--text pt-3 mx-2" data-qa="termdepositactions-flex-73rjjo">
                {{ $t("termDepositActions.depositAcLabel") }} ({{ productDetails.accountId }})
              </v-flex>
            </v-row>
            <v-row class="px-4" data-qa="termdepositactions-row-wceeou">
              <v-layout row wrap data-qa="termdepositactions-layout-xod8g1q">
                <v-flex xs6 sm4 md4 lg4 xl6 class="px-1" data-qa="termdepositactions-flex-8wk695">
                  <font class="subtitle-1 font-weight-medium white--text">{{
                    $t("termDepositActions.depositAmount")
                  }}</font>
                </v-flex>
                <v-flex xs6 sm4 md4 lg4 xl6 class="px-1 pt-1" data-qa="termdepositactions-flex-70avnl">
                  <font class="subheading-1 font-weight-medium white--text">{{
                    $t("termDepositActions.maturityAmount")
                  }}</font>
                </v-flex>
              </v-layout>
            </v-row>
            <v-row class="px-4" v-if="productDetails.currentBalance" data-qa="termdepositactions-row-d8oheh">
              <v-layout data-qa="termdepositactions-layout-vsl3ui">
                <v-flex xs6 sm4 md4 lg4 xl6 class="px-1" data-qa="termdepositactions-flex-hzo2sr">
                  <font class="text-h5 font-weight-bold white--text">{{
                    $formatter.currency.format(
                      productDetails.currentBalance.value
                    )
                  }}</font>
                </v-flex>
                <v-flex xs6 sm4 md4 lg4 xl6 class="px-1" data-qa="termdepositactions-flex-7oilop">
                  <font class="text-h5 font-weight-bold white--text">{{
                    $formatter.currency.format(
                      productDetails.maturityAmount.value
                    )
                  }}</font>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <Stepper :options="stepConfig" />
    <ConfirmExit v-if="isLeavingRoute" v-on:isLeavingRoute="proceedLeave" v-on:isNotLeavingRoute="cancelLeave"/>
  </v-flex>
</template>

<script>
import router from '@/core/router'
import _ from 'lodash'
import event from '@/util/event'
import Loader from '../../../components/common/Loader.vue'

const setBreadcrumb = router.options.routes.find(element => element.name === 'TermDepositActions')

export default {
  name: 'TermDepositActions',
  data () {
    return {
      loaderEnabled: false,
      productDetails: {},
      actionType: '',
      stepConfig: null,
      amendDeposit: {
        component: 'AmendDeposit',
        config: {
          step: 1,
          enableBackBtn: true,
          disableNextBtn: true,
          enableOTP: this.$appSettings.defaultConfigurations.enableOTPForAmendTD,
          stepName: 'amendOptionBoth',
          steps: [{
            name: 'amendOptionBoth'
          }]
        }
      },
      breakDeposit: {
        component: 'BreakDeposit',
        config: {
          step: 1,
          enableBackBtn: true,
          disableNextBtn: true,
          enableOTP: this.$appSettings.defaultConfigurations.enableOTPForCloseTD,
          stepName: 'breakageType',
          steps: [{
            name: 'breakageType'
          },
          {
            name: 'selectPayAwayAccount'
          },
          {
            name: 'reviewAccountDetails'
          }]
        }
      },
      isLeavingRoute: false,
      to: null,
      refresh: true,
      amendDepositDataSanity: false,
      closeDepositDataSanity: false,
      isAmendDepositComplete: false,
      isCloseDepositComplete: false,
      isLogout: false
    }
  },
  components: {
    Loader,
    Stepper: () => import('@/views/accounts/termDepositActions/Stepper.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue')
  },
  created () {
    if (this.$route.params.product !== undefined) {
      this.productDetails = this.$route.params.product
      this.actionType = this.$route.params.action
    } else {
      this.$router.push({ path: '/home' })
    }
    this.setStepConfig()
    this.dataSanityCheck()
    setBreadcrumb.meta.breadcrumb.subTitle = _.startCase(this.$route.params.action)
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  beforeRouteLeave (to, from, next) {
    if ((this.amendDepositDataSanity && !this.isAmendDepositComplete) || (this.closeDepositDataSanity && !this.isCloseDepositComplete)) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Deposit2')
    },
    dataSanityCheck () {
      event.$on('amendDepositDataSanity', arg => {
        this.amendDepositDataSanity = arg
      })
      event.$on('closeDepositDataSanity', arg => {
        this.closeDepositDataSanity = arg
      })
      event.$on('amendDepositComplete', arg => {
        this.isAmendDepositComplete = arg
      })
      event.$on('closeDepositComplete', arg => {
        this.isCloseDepositComplete = arg
      })
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    setStepConfig () {
      switch (this.$route.params.action) {
        case 'amend':
          this.stepConfig = {
            ...this.$route.params,
            ...this.amendDeposit
          }
          break
        case 'break':
          this.stepConfig = {
            ...this.$route.params,
            ...this.breakDeposit
          }
          break
        default:
          this.$router.push({ name: 'Home' })
          break
      }
    }
  }
}
</script>

<style></style>
